import { useQuery } from "@tanstack/react-query";
import { hub } from "@/lib/hub-client";

export interface WalletBalance {
  user_id: string;
  available: number;
  held: number;
  spendable: number;
  total: number;
  by_cohort: Array<{
    id: string;
    kind: "subscription" | "topup" | "rescue";
    amount_remaining: number;
    expires_at: number;
  }>;
}

export function useWallet(enabled: boolean = true) {
  return useQuery({
    queryKey: ["wallet"],
    queryFn: async () => {
      const res = await hub.GET<WalletBalance>("/v1/me/wallet");
      if (!res.data) throw new Error("wallet fetch failed");
      return res.data;
    },
    enabled,
    staleTime: 5_000,
  });
}
